import React from "react";
import themeLarge from "../ThemeLarge";
import ProjectSortYearView from "./ProjectSortYear";

class ProjectSortView extends React.Component {
  constructor(props) {
    super(props);
    const currentYear = new Date().getFullYear();
    this.labels = [
      "All",
      currentYear,
      currentYear - 1,
      currentYear - 2,
      "Older",
    ];
    this.state = {
      activeLabel: "All",
    };
  }

  handleClick = (label) => {
    this.setState({ activeLabel: label });

    // Send selected label to parent
    if (this.props.onFilterChange) {
      this.props.onFilterChange(label);
    }
  };

  render() {
    return (
      <div
        className="row"
        style={{
          paddingLeft: "30px",
          paddingBottom: "10px",
        }}
      >
        <div className="col-md-2">
          <p
            className="d-flex justify-content-center"
            style={{
              fontFamily: "Kumbh Sans",
              fontSize: themeLarge.fontSize.h3,
              color: themeLarge.colors.text,
              paddingTop: "10px",
              paddingBottom: "10px",
            }}
          >
            Sort
          </p>
        </div>

        {this.labels.map((label, index) => (
          <div
            className="col-md-2"
            key={index}
            onClick={() => this.handleClick(label)}
          >
            <ProjectSortYearView
              label={label.toString()}
              active={this.state.activeLabel === label}
            />
          </div>
        ))}
      </div>
    );
  }
}

export default ProjectSortView;
